import { handleActions } from 'redux-actions';
import actions from '../actions';

const { edit, reset } = actions.orderStep;

const defaultState = 'order';

const orderStep = handleActions(
  {
    [edit]: (state, { payload }) => payload,
    [reset]: () => defaultState,
  },
  defaultState
);

export default orderStep;



// WEBPACK FOOTER //
// ./src/reducers/orderStep.js